"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tiers = void 0;
const schemas_1 = require("@dcl/schemas");
const abis_1 = require("../abis");
exports.tiers = {
    [schemas_1.ChainId.MATIC_MUMBAI]: {
        version: '1',
        abi: abis_1.abis.Tiers,
        address: '0xdc899b9c1fa80292606c3cfba88bbbf0935c2e48',
        name: 'Decentraland Third Party Tiers',
        chainId: schemas_1.ChainId.MATIC_MUMBAI
    }
};
//# sourceMappingURL=tiers.js.map